import { isCountableMSService } from './MSServices'
import type { ISelectItem, IItemWithStatus } from '~/types/models'
import type { TMSService } from '~/types/msService/models'
import { assertIsNumber } from '~/types/models'

export function countUniqueStatii(itemsWithStatus: IItemWithStatus[]): {
  status: ISelectItem
  count: number
}[] {
  const statusList = itemsWithStatus.map(
    (itemWithStatus) => itemWithStatus.status
  )
  const map = Map.groupBy(statusList, (item) => item.id)
  const countsList = [...map.values()].map((value) => ({
    status: value[0],
    count: value.length,
  }))
  return countsList.sort(_sortCountsListItemsByStatusId)
}
function _sortCountsListItemsByStatusId(
  a: {
    status: ISelectItem
    count: number
  },
  b: {
    status: ISelectItem
    count: number
  }
) {
  assertIsNumber(a.status.id)
  assertIsNumber(b.status.id)
  return a.status.id - b.status.id
}
